export default __webpack_public_path__ + "static/media/islam.ed802652.svg";